<template>
	<div
		v-if="isVisibleOnFeatureSwitch"
		:class="[
			'btn-action-ribbon-menu',
			expanded && 'is-open',
			disabled && 'is-disabled',
			disabled
				? 'is-disabled'
				: isLoading
				? 'is-disabled'
				: hasLoaded
				? 'is-disabled'
				: '',
			isLoading && 'is-loading',
			hasLoaded && 'has-loaded'
		]"
		:disabled="disabled"
		tabindex="0"
		ref="popperReference"
	>
		<div class="btn-action-ribbon-menu__btn-container" @click="showOptions">
			<ButtonActionRibbon
				:labelText="labelText"
				:iconClassName="iconMenuClassName"
			/>
			<BtnTrigger
				class="btn-action-ribbon-menu__trigger"
				:expanded="expanded"
			/>
		</div>
		<PopperPosition
			trackedRefName="popperReference"
			popoverRefName="popper"
			placement="bottom-start"
			:popperVisible="expanded"
			strategy="fixed"
			@popperMinWidthChanged="setpopperMinWidth"
		/>
		<Menu
			:options="options"
			:visible="expanded"
			:minWidth="popperMinWidth"
			@change="onSelectOption"
			ref="popper"
		/>
		<ButtonProgress
			:isLoading="isLoading"
			:hasLoaded="hasLoaded"
			:hasError="hasError"
			:errorMessage="errorMessage"
			:isActionRibbon="true"
		/>
	</div>
</template>

<script>
import ButtonActionRibbon from './button-action-ribbon.vue';
import BtnTrigger from '@/components/forms/shared-stateless-elements/btn-trigger.vue';
import baseComponentMixin from '@/mixins/base-component-mixin';
import Menu from '../menu/menu.vue';
import ButtonProgress from '@/components/visual/loader/button-progress.vue';
import baseButtonMixin from '@/mixins/base-button-mixin';
import buttonMenuMixin from '@/mixins/button-menu-mixin';
import PopperPosition from '@/components/visual/popper-position/popper-position.vue';

export default {
	name: 'ButtonActionRibbonMenu',
	components: {
		Menu,
		ButtonActionRibbon,
		BtnTrigger,
		ButtonProgress,
		PopperPosition
	},
	mixins: [baseComponentMixin, baseButtonMixin, buttonMenuMixin]
};
</script>

<style lang="scss" scoped>
.btn-action-ribbon-menu {
	display: inline-block;
	position: relative;

	&__btn-container {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__btn-action-ribbon {
		pointer-events: none;
	}

	&:deep(.btn-trigger) {
		padding-right: 0;
	}

	&:focus-visible {
		outline: none;
	}
}
/* LL styles v1 Only */
.btn-action-ribbon-menu {
	color: var(--bg-2-fg-3);

	&:hover,
	&:focus,
	&:active,
	&:focus-visible {
		.btn-action-ribbon-menu__trigger,
		&:deep(.btn-action-ribbon) {
			color: var(--link-hover);
		}

		&:deep(.btn-action-ribbon__label) {
			border-color: var(--link-hover);
		}
	}

	&:deep(.btn-action-ribbon) {
		&:hover,
		&:focus,
		&:active {
			+ .btn-action-ribbon-menu__trigger {
				color: var(--link-hover);
			}
		}
	}
}

/* LL styles v2 Only */
/* .btn-action-ribbon-menu {
	color: var(--bg-brand-2-fg-2);
} */
</style>
